module.exports = "//static.hsappstatic.net/ContentComponents/static-2.69584/img/content-remix-post-publish/content-remix-de.png"